import { Component, Inject, Optional } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { BusinessTransactionService } from '../../shared/services/business-transaction/business-transaction.service';
import { RegenerateArtifactContext } from './regenerate-artifact-context.model';
import { BaseComponent } from '../../shared/base-components/base.component';

@Component({
    selector: 'regenerate-artifact-modal',
    templateUrl: './regenerate-artifact-modal.component.html',
    styles: []
})
export class RegenerateArtifactModalComponent extends BaseComponent {

    businessTransactionNumberId: number;
    businessTransactionDetails: string;
    public modalTitle = 'ReCreate Artifacts';
    public documentTypes: any;
    public documentType: any;
    public addArtifactsForm: UntypedFormGroup;
    public isProcessing = false;

    constructor(private fb: UntypedFormBuilder,
        public dialogRef: MatDialogRef<RegenerateArtifactModalComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: RegenerateArtifactContext,
        private businessTransactionService: BusinessTransactionService, ) {
        super();
        this.businessTransactionNumberId = this.data.businessTransactionNumberId;
        this.businessTransactionDetails = this.data.businessTransactionDetails;
        this.documentTypes = this.data.documentTypes;
    }

    public cancel() {
        this.dialogRef.close();
    }

    ngOnInit() {
        this.addArtifactsForm = this.fb.group({
            documentTypeId: [null, Validators.required],
        });
    }

    /**
    * recreate the artifacts
    * @param businessTransactionNumberId
    */
    public reCreateArtifacts() {
        let formValue = this.addArtifactsForm.value;
        if (formValue && formValue.documentTypeId) {
            this.isProcessing = true;
            this.businessTransactionService.reCreateArtifacts(this.businessTransactionNumberId, formValue.documentTypeId)
                .subscribe(result => {
                    this.isProcessing = false;
                    this.dialogRef.close();
                }, error => {
                    this.isProcessing = false;
                    this.handleValidationResult(error);
                });
        }
    }

}
